// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__S5YcU","checkboxCol":"Table_checkboxCol__2_veJ","emailCol":"Table_emailCol__2ZXsx","actionCol":"Table_actionCol__2m1C4"};